/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TransactionSummary } from './TransactionSummary';
import {
    TransactionSummaryFromJSON,
    TransactionSummaryFromJSONTyped,
    TransactionSummaryToJSON,
} from './TransactionSummary';

/**
 * 
 * @export
 * @interface TransactionSummaryViewModel
 */
export interface TransactionSummaryViewModel {
    /**
     * 
     * @type {TransactionSummary}
     * @memberof TransactionSummaryViewModel
     */
    transactionSummary: TransactionSummary;
}

/**
 * Check if a given object implements the TransactionSummaryViewModel interface.
 */
export function instanceOfTransactionSummaryViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "transactionSummary" in value;

    return isInstance;
}

export function TransactionSummaryViewModelFromJSON(json: any): TransactionSummaryViewModel {
    return TransactionSummaryViewModelFromJSONTyped(json, false);
}

export function TransactionSummaryViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionSummaryViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transactionSummary': TransactionSummaryFromJSON(json['TransactionSummary']),
    };
}

export function TransactionSummaryViewModelToJSON(value?: TransactionSummaryViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'TransactionSummary': TransactionSummaryToJSON(value.transactionSummary),
    };
}

